import chain from '@/lib/axios-chain'
// 表单管理-获取表单列表
export const getSmartFormList = () =>
  chain.create('/universal/form/list', 'get')
// 表单启用/停用
export const formStartOrEnd = () =>
  chain.create('/universal/form/status', 'get')
// 设置表单备注
export const setFormRemark = () =>
  chain.create('/universal/form/remark', 'post')
// 复制地址|代码
export const copyCodeAddress = () =>
  chain.create('/universal/form/script', 'get')
// 复制表单
export const copyForm = () => chain.create('/universal/form/copy', 'get')
// 删除表单
export const deleteForm = () => chain.create('/universal/form/delete', 'get')
// 导出提交记录
export const exportSubmitRecord = () =>
  chain.create('/universal/history/getUrl', 'get')
// 获取提交记录、拦截记录
export const getRecord = () => chain.create('/universal/history/list', 'get')
// 获取记录详情
export const getDetail = () => chain.create('/universal/history/content', 'get')
// 获取表单名字分类
export const getFormCategory = () =>
  chain.create('/universal/form/listName', 'get')
// 标记已读
export const setRead = () => chain.create('/universal/history/setRead', 'get')
// 标记不处理
export const setDeal = () => chain.create('/universal/history/markSkip', 'post')
// 取消拦截
export const cancelIntercept = () =>
  chain.create('/universal/history/cancel', 'get')
// 批量删除提交记录
export const delRecords = () => chain.create('/universal/history/del ', 'post')
// 获取外部表单权限
export const universalPermissions = () =>
  chain.create('/universal/form/permissions', 'get')
